module.exports = __webpack_public_path__ + "img/edit_color_256.ea6fb86c.png";